export const CLEAR_DIALOUGE = "CLEAR_DIALOUGE";

export const FETCH_GETDIAGNOSIS_REQUEST = "FETCH_GETDIAGNOSIS_REQUEST";
export const FETCH_GETDIAGNOSIS_SUCCESS = "FETCH_GETDIAGNOSIS_SUCCESS";
export const FETCH_GETDIAGNOSIS_FALIURE = "FETCH_GETDIAGNOSIS_FALIURE";

export const POST_GETDIAGNOSIS_REQUEST = "POST_GETDIAGNOSIS_REQUEST";
export const POST_GETDIAGNOSIS_SUCCESS = "POST_GETDIAGNOSIS_SUCCESS";
export const POST_GETDIAGNOSIS_FALIURE = "POST_GETDIAGNOSIS_FALIURE";

export const FETCH_MASTERDAIGNOSIS_REQUEST = "FETCH_MASTERDAIGNOSIS_REQUEST";
export const FETCH_MASTERDAIGNOSIS_SUCCESS = "FETCH_MASTERDAIGNOSIS_SUCCESS";
export const FETCH_MASTERDAIGNOSIS_FALIURE = "FETCH_MASTERDAIGNOSIS_FALIURE";

export const DELETE_DIAGNOSIS_REQUEST = "DELETE_DIAGNOSIS_REQUEST";
export const DELETE_DIAGNOSIS_SUCCESS = "DELETE_DIAGNOSIS_SUCCESS";
export const DELETE_DIAGNOSIS_FALIURE = "DELETE_DIAGNOSIS_FALIURE";

export const UPDATE_DIAGNOSIS_REQUEST = "UPDATE_DIAGNOSIS_REQUEST";
export const UPDATE_DIAGNOSIS_SUCCESS = "UPDATE_DIAGNOSIS_SUCCESS";
export const UPDATE_DIAGNOSIS_FALIURE = "UPDATE_DIAGNOSIS_FALIURE";

export const FETCH_DAIGNOSISCLASSES_REQUEST = "FETCH_DAIGNOSISCLASSES_REQUEST";
export const FETCH_DAIGNOSISCLASSES_SUCCESS = "FETCH_DAIGNOSISCLASSES_SUCCESS";
export const FETCH_DAIGNOSISCLASSES_FALIURE = "FETCH_DAIGNOSISCLASSES_FALIURE";

export const FETCH_DAIGNOSISDESCRIPTION_REQUEST =
  "FETCH_DAIGNOSISDESCRIPTION_REQUEST";
export const FETCH_DAIGNOSISDESCRIPTION_SUCCESS =
  "FETCH_DAIGNOSISDESCRIPTION_SUCCESS";
export const FETCH_DAIGNOSISDESCRIPTION_FALIURE =
  "FETCH_DAIGNOSISDESCRIPTION_FALIURE";
export const EDIT_PAITENT_DIAGNOSIS = "EDIT_PAITENT_DIAGNOSIS";
export const CHANGE_EDIT_MODE = "CHANGE_EDIT_MODE";
